import React from 'react';
import { CardSettingsProvider } from '../../../contexts/card/settings/context';
import MainLayout from './partials/MainLayout';
import VerifyUserPassword from './VerifyUserPassword';
import { cardSettingsScreens } from './constants';
import SetPin from './SetPin';
import ReportCardIssue from './ReportCardIssue';
import ConfirmReportCard from './ConfirmReportCard';
import ConfirmReplacementCardDetails from './ConfirmReplacementCardDetails';
import OrderReplacementCard from './OrderReplacementCard';
import LastFiveTransactions from './LastFiveTransactions';
import EditMailingAddress from './editMailingAddress';
import ConfirmDeliveryType from './ConfirmDeliveryType';
import NotRecognizedTx from './NotRecognizedTx';
import ConfirmExpeditedAmount from './ConfirmExpeditedAmount';
import ErrorTx from './ErrorTx';

const CardSettings = () => (
  <CardSettingsProvider>
    <MainLayout>
      <VerifyUserPassword keyName={cardSettingsScreens.VERIFY_PASSWORD} />
      <SetPin keyName={cardSettingsScreens.SET_PIN} />
      <ReportCardIssue keyName={cardSettingsScreens.REPORT_CARD_ISSUE} />
      <ConfirmReportCard keyName={cardSettingsScreens.REPORT_CARD_CONFIRM} />
      <ConfirmReplacementCardDetails
        keyName={cardSettingsScreens.CONFIRM_REPLACEMENT_CARD_DETAILS}
      />
      <OrderReplacementCard keyName={cardSettingsScreens.ORDER_REPLACEMENT_CARD} />
      <LastFiveTransactions keyName={cardSettingsScreens.LAST_FIVE_TRANSACTIONS} />
      <EditMailingAddress keyName={cardSettingsScreens.EDIT_MAILING_ADDRESS} />
      <ConfirmDeliveryType keyName={cardSettingsScreens.CONFIRM_DELIVERY_TYPE} />
      <NotRecognizedTx keyName={cardSettingsScreens.NOT_RECOGNIZED_TX} />
      <ConfirmExpeditedAmount keyName={cardSettingsScreens.CONFIRM_EXPEDITED_AMOUNT} />
      <ErrorTx keyName={cardSettingsScreens.ERROR_TX} />
    </MainLayout>
  </CardSettingsProvider>
);

export default CardSettings;
